export default "__VITE_ASSET__a3d58b4f__"